
import { Badge } from "@/components/ui/badge";
import { useBookingStatuses } from "@/hooks/useBookingStatuses";
import { getStatusColor, getStatusDisplayName } from "@/types/booking-status";

export const BookingStatusBadge = ({ status }: { status: string }) => {
  const { data: statuses = [] } = useBookingStatuses();
  
  // Use database-driven helper functions
  const statusColor = getStatusColor(status, statuses);
  const displayName = getStatusDisplayName(status, statuses);
  
  return (
    <Badge 
      className="font-medium rounded-xl px-3 h-9 flex items-center justify-center text-sm w-full md:w-auto"
      style={{
        backgroundColor: `${statusColor}20`,
        color: statusColor,
        border: `1px solid ${statusColor}40`
      }}
    >
      {displayName}
    </Badge>
  );
};

// Helper function to get status color for other components
export const getStatusColorHelper = (status: string, statuses: any[] = []) => {
  return getStatusColor(status, statuses);
};
